/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class AccountGroupAccountDialog extends SiteEntityDialog<AccountGroupAccountRow, any> {
        protected getFormKey() { return AccountGroupAccountForm.formKey; }
        protected getIdProperty() { return AccountGroupAccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountGroupAccountRow.localTextPrefix; }
        protected getNameProperty() { return AccountGroupAccountRow.nameProperty; }
        protected getService() { return AccountGroupAccountService.baseUrl; }

        protected form = new AccountGroupAccountForm(this.idPrefix);

    }
}